import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router";

import ErrorFallback from "@/components/sharedComponents/ErrorFallback";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

function RoleWrapper({ allowedRoles }) {
  const { workflow } = useUpdateDataContext();

  const isAuthorized = allowedRoles.includes(workflow);

  if (isAuthorized) {
    return <Outlet />;
  } else {
    return (
      <ErrorBoundary
        fallbackRender={({ error }) => (
          <ErrorFallback error={error} redirect="/" />
        )}
      ></ErrorBoundary>
    );
  }
}

export default RoleWrapper;
